import type { Deal } from '../../types/domain';
import { dealRevenueForYear } from './soldRevenue';
import type { Year } from './types';

// ── C.A par année (fiche contact) ────────────────────────────────────────────
// Même répartition que le dashboard (règle 1.5) : forfait en entier sur l'année de signature
// (date_devis_accepte), récurrent au prorata des mois du contrat avec les dates de la ligne
// vendue. Jamais les dates réelles de la phase : le CA d'une affaire pour une année doit être
// identique sur le dashboard et sur la fiche contact.
export function dealActualRevenueForYear(a: Deal, year: Year): number {
  return dealRevenueForYear(a, year);
}
